import axios from "axios";

import { API_URL as BASE_URL } from "../config";

export const createHubsetupExpense = async(payload) => {
    try {
        const response = await axios.post(`${BASE_URL}/expense/create`, payload)
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const uploadHubSetupBill = async(payload, expense_id) => {
    try {
        const response = await axios.post(`${BASE_URL}/expense-ocr/analyze-setup/${expense_id}`, payload);
        return response.data;
    } catch (error) {
        throw error;
    }
}